import identify from 'app/analytics/identify';
import page from 'app/analytics/page';
import authentication from 'app/features/authentication/analytics';
import products from 'app/features/products/analytics';
import watchlist from 'app/features/watchlist/analytics';
import helpCenter from 'app/features/helpCenter/analytics';
import homeButton from 'app/features/header/analytics';
import viewPlansCta from 'app/features/landing/viewPlansCta/analytics';
import footer from 'app/features/footer/analytics';
import success from 'app/features/success/analytics';

export default {
  ...page,
  ...identify,
  ...products,
  ...authentication,
  ...watchlist,
  ...helpCenter,
  ...homeButton,
  ...viewPlansCta,
  ...footer,
  ...success,
};
